import React, { useEffect, useState } from 'react';
import Modal from '../../../components/common/Modal/modal';
import ErrorDisplay from '../../../components/common/Error/Error';
import { Link } from "react-router-dom";
import Header from '../../../components/common/Header/header';
import BlogTiles from '../../../components/ui/BlogTiles/blogTiles';
import BlogPopup from '../../../components/ui/BlogPopup/blogPopup';
import './Blog.css';
import { useBlog } from '../../../hooks/useBlog';

function Blog({ isVisible }) {
    const {
        blogs,
        selectedBlog,
        loadingBlogs,
        loadingBlogDetails,
        error,
        fetchBlogs,
        fetchBlogById,
        setSelectedBlog,
    } = useBlog();

    const [isModalOpen, setModalOpen] = useState(false);

    useEffect(() => {
        fetchBlogs();
    }, [fetchBlogs]);

    const handlePostClick = async (id) => {
        setSelectedBlog(null);
        setModalOpen(true);
        const data = await fetchBlogById(id);
        if (!data) {
            setModalOpen(false);
        }
    };

    const shouldShow = isVisible !== false;

    if (!shouldShow) return null;

    return (
        <div className="blog">
            <div className="blog-header">
                <Header />
            </div>
            <div className="blog-content">
                {loadingBlogs ? (
                    <p>Chargement...</p>
                ) : error ? (
                    <ErrorDisplay errorData={error} />
                ) : (
                    <ul className="blog-content-list">
                        {blogs.map((post) => (
                            <li key={post.id} className="blog-content-list-item">
                                <div
                                    className="blog-tiles-wrapper"
                                    // Added onClick that explicitly prevents default
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        handlePostClick(post.id);
                                    }}
                                    role="button"
                                    tabIndex={0}
                                    onKeyDown={e => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            handlePostClick(post.id);
                                        }
                                    }}
                                >
                                    <BlogTiles 
                                        title={post.title} 
                                        subtitle={post.subtitle} 
                                        excerpt={post.excerpt}
                                        thumbnail={post.thumbnail} 
                                    />
                                </div>
                            </li>
                        ))}
                    </ul>
                )}
                <footer>
                    <Link to="/legal-mention">Mentions légales</Link>
                </footer>
            </div>
            
            <Modal isOpen={isModalOpen} onClose={() => setModalOpen(false)}>
                {loadingBlogDetails ? (
                    <p>Chargement de l'article...</p>
                ) : (
                    <BlogPopup blog={selectedBlog} />
                )}
            </Modal>
        </div>
    );
}

export default Blog;